import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { timer } from 'rxjs';

@Component({
    selector: 'pickright-button',
    templateUrl: './button.component.html',
    styles: []
})
export class PickrightButtonComponent implements OnInit {
    @Input() size: 'small' | 'regular' | 'large' = 'regular';
    @Input() type: 'fill' | 'outline' | 'link' = 'fill';
    @Input() color: 'primary' | 'secondary' | 'danger' | 'success' | 'warning' = 'primary';
    @Input() link: string = null;
    @Input() text: string;
    @Input() cssClass: string = '';
    @Input() disabled: boolean = false;
    @Input() buttonType: 'button' | 'submit' = 'button'
    // @Output() click = new EventEmitter();
    @Output() btnClick = new EventEmitter();

    constructor(
        @Inject(PLATFORM_ID) private readonly _platformId: Object
    ) { }

    ngOnInit(): void {
    }

    onClick(event: Event) {
        if (isPlatformBrowser(this._platformId))
            this.btnClick.emit(event);
    }

}
